import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen bg-onyx-black flex items-center justify-center text-white/60"><Loader2 className="animate-spin mr-3" /> Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  if (!user.is_admin) return <Navigate to="/admin/login" replace state={{ error: "not_admin" }} />;
  return <Outlet />;
}
